/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Status_Awaiting_CheckoutInputs */



/**
* | output |
* | --- |
* | "Awaiting checkout" |
*
* @param {Dashboard_Status_Awaiting_CheckoutInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const dashboard_status_awaiting_checkout = /** @type {((inputs?: Dashboard_Status_Awaiting_CheckoutInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Status_Awaiting_CheckoutInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ожидает оплаты")
	return /** @type {LocalizedString} */ ("Awaiting checkout")
});